import {
  Link,
  Outlet,
  createFileRoute,
  redirect,
  useLocation,
} from "@tanstack/react-router";
import { Code, CreditCard } from "lucide-react";

export const Route = createFileRoute("/(app)/settings")({
  component: RouteComponent,
  beforeLoad: ({ location }) => {
    if (location.pathname === "/settings") {
      throw redirect({ to: "/settings/installation", replace: true });
    }
  },
  loader: async ({ context }) => {
    return {
      crumb: {
        label: "Settings",
        options: [],
        id: "settings",
      },
    };
  },
});

function RouteComponent() {
  const { pathname } = useLocation();

  return (
    <div className="flex gap-8 mx-auto">
      <nav className="w-60 shrink-0">
        <ul className="space-y-1">
          <li>
            <Link
              to="/settings/installation"
              className={`flex items-center gap-2 rounded-md px-3 py-2 text-sm ${
                pathname === "/settings/installation"
                  ? "bg-accent text-accent-foreground"
                  : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
              }`}
            >
              <Code className="size-3.5" />
              Installation
            </Link>
          </li>
          <li>
            <Link
              to="/settings/billing"
              className={`flex items-center gap-2 rounded-md px-3 py-2 text-sm ${
                pathname === "/settings/billing"
                  ? "bg-accent text-accent-foreground"
                  : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
              }`}
            >
              <CreditCard className="size-3.5" />
              Plans & Billing
            </Link>
          </li>
        </ul>
      </nav>
      <div className="flex-1">
        <div className="w-3xl flex flex-col gap-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
